import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 py-6">
        <div className="max-w-4xl mx-auto px-6 sm:px-8">
          <Button 
            onClick={() => navigate('/')}
            variant="ghost"
            className="mb-4 text-gray-700 hover:text-[#FFD000]"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
          <h1 className="text-3xl sm:text-4xl font-bold text-black">
            Yu<span className="text-[#FFD000]">Zu</span> Recruitment Services
          </h1>
          <p className="text-sm text-gray-600 mt-1">Zest for the right Talent</p>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 sm:px-8 py-12">
        <h1 className="text-4xl font-bold text-black mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">1. Introduction</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              1.1. These Terms of Service outline how YuZu Recruitment Services provides recruitment and workforce consultancy services to clients within the hospitality industry.
            </p>
            <p className="text-gray-700 leading-relaxed">
              1.2. By engaging with YuZu Recruitment Services, you acknowledge and accept these terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">2. Service Provision</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              2.1. YuZu Recruitment Services provides recruitment and workforce advisory services including candidate sourcing, structured screening, and client consultation.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              2.2. All candidates presented are assessed based on experience, behavioural indicators, and role alignment.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              2.3. Final hiring decisions remain the responsibility of the client.
            </p>
            <p className="text-gray-700 leading-relaxed">
              2.4. YuZu does not guarantee candidate performance or tenure.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">3. Notification of Placement</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              3.1. Clients are required to notify YuZu Recruitment Services of any engagement of a candidate introduced by YuZu within a 12-month period from the date of introduction.
            </p>
            <p className="text-gray-700 leading-relaxed">
              3.2. Such engagements will be subject to the applicable placement fee.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">4. Placement Fees</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              4.1. YuZu Recruitment Services operates on a structured fee model aligned with the scope and level of engagement.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              4.2. Depending on the nature of the assignment, services may be provided on a retained or success-based basis.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              4.3. All commercial terms, including applicable fees, are discussed and confirmed prior to commencement of any engagement.
            </p>
            <p className="text-gray-700 leading-relaxed">
              4.4. Placement fees are typically calculated as a percentage of the candidate's total annual remuneration.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">5. Payment Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              5.1. Upon the commencement of the candidate's employment, the Agency will issue a formal invoice to the Client detailing the placement fee due, calculated according to Clause 4.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              5.2. The Client agrees to remit full payment of the invoiced amount within fourteen (14) calendar days from the date of the invoice.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              5.3. Invoices are issued upon candidate commencement and are payable within 14 days.
            </p>
            <p className="text-gray-700 leading-relaxed">
              5.4. Full payment is required for the placement to be considered complete.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">6. Guarantee Period and Replacement</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              6.1. YuZu Recruitment Services offers a 30-day replacement guarantee.
            </p>
            <p className="text-gray-700 leading-relaxed">
              6.2. If a placed candidate leaves within this period under reasonable circumstances, YuZu will conduct a replacement search at no additional placement fee, subject to agreed conditions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">7. Ownership of Introduction & Liability for Unauthorized Engagement</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              7.1. Candidate introductions remain valid for a period of 12 months.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              7.2. Should a candidate introduced by YuZu Recruitment Services be engaged during this period, directly or indirectly, the standard placement fee will apply.
            </p>
            <p className="text-gray-700 leading-relaxed">
              7.3. This includes engagements through associated entities or third parties.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">8. Confidentiality</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              8.1. All candidate information shared by YuZu Recruitment Services is confidential and intended solely for internal evaluation.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              8.2. Clients may not share candidate information with third parties without prior consent.
            </p>
            <p className="text-gray-700 leading-relaxed">
              8.3. Both parties agree that all candidate and business information shared under this Agreement is strictly confidential and may not be disclosed to any third party without prior written consent.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">9. Protection of Personal Information</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              9.1. YuZu Recruitment Services processes personal information in accordance with applicable data protection laws, including POPIA.
            </p>
            <p className="text-gray-700 leading-relaxed">
              9.2. Candidate information is shared with clients only with appropriate consent.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">10. Liability</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              10.1. YuZu Recruitment Services applies professional diligence in candidate sourcing and screening.
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              10.2. However, all hiring decisions and outcomes remain the responsibility of the client.
            </p>
            <p className="text-gray-700 leading-relaxed">
              10.3. YuZu shall not be liable for any indirect, consequential, or operational losses arising from employment decisions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">11. Governing Law and Jurisdiction</h2>
            <p className="text-gray-700 leading-relaxed">
              11.1. These Terms are governed by the laws of the Republic of South Africa.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-black mb-4">12. Engagement Basis</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              12.1. Formal recruitment engagement begins once terms are agreed and confirmed between YuZu Recruitment Services and the client.
            </p>
            <p className="text-gray-700 leading-relaxed">
              12.2. YuZu reserves the right to accept or decline assignments based on scope, alignment, and operational capacity.
            </p>
          </section>

          <div className="bg-gray-100 border-l-4 border-[#FFD000] p-6 mt-12">
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>YuZu Recruitment Services Pty (Ltd)</strong>
            </p>
            <p className="text-gray-700 leading-relaxed mb-2">
              <strong>Website:</strong> <a href="http://www.yuzurecruit.co.za" className="text-[#FFD000] hover:underline" target="_blank" rel="noopener noreferrer">www.yuzurecruit.co.za</a>
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              <strong>Email:</strong> <a href="mailto:info@yuzurecruit.co.za" className="text-[#FFD000] hover:underline">info@yuzurecruit.co.za</a>
            </p>
            <p className="text-sm text-gray-600 mt-4">
              <strong>Document Reference Code:</strong> YU/REC/2025-v1
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
